import { CookieConsentConfig } from 'vanilla-cookieconsent';

export const CCConfig: CookieConsentConfig = {
  revision: 1,
  guiOptions: {
    consentModal: {
      layout: 'box',
      position: 'bottom right',
      equalWeightButtons: true,
      flipButtons: false
    },
    preferencesModal: {
      layout: 'box',
      position: 'right',
      equalWeightButtons: true,
      flipButtons: false
    }
  },
  categories: {
    necessary: {
      readOnly: true,
      services: {
        session: {
          label: 'Sitzung'
        },
        basket: {
          label: 'Warenkorb'
        },
        paypal: {
          label: 'Paypal-Zahlungen'
        }
      }
    },
    marketing: {
      services: {
        meta_pixel: {
          label: 'Meta Pixel'
        },
        tiktok_pixel: {
          label: 'Tiktok Pixel'
        },
        klavyio: {
          label: 'Klavyio'
        }
      }
    }
  },
  language: {
    default: 'de',
    autoDetect: 'browser',
    translations: {
      de: {
        consentModal: {
          title: 'Diese Website verwendet Cookies',
          description:
            'Diese Website verwendet Cookies, um eine möglichst optimale und benutzerfreundliche Erfahrung zu bieten und die Nutzung der Inhalte kontinuierlich zu verbessern.',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Alle ablehnen',
          showPreferencesBtn: 'Einstellungen verwalten',
          footer: '<a href="https://www.wellext.de/legal/datenschutz">Datenschutz</a>',
          revisionMessage:
            'Hallo, seit deinem letzten Besuch haben wir einige Änderungen an unserer Cookie-Richtlinie vorgenommen!'
        },
        preferencesModal: {
          title: 'Präferenzen für die Zustimmung',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Alle ablehnen',
          savePreferencesBtn: 'Einstellungen speichern',
          closeIconLabel: 'Modal schließen',
          serviceCounterLabel: 'Dienstleistungen',
          sections: [
            {
              title: 'Verwendung von Cookies',
              description:
                'Diese Website verwendet Cookies, um eine möglichst optimale und benutzerfreundliche Erfahrung zu bieten und die Nutzung der Inhalte kontinuierlich zu verbessern.'
            },
            {
              title: 'Streng Notwendige Cookies <span class="pm__badge">Immer Aktiviert</span>',
              description: 'Für die Funktion der Website erforderliche Cookies:',
              linkedCategory: 'necessary'
            },
            {
              title: 'Marketing Cookies',
              description: 'Diese Cookies werden verwendet um personalisierte Werbung anzuzeigen.',
              linkedCategory: 'marketing'
            },
            {
              title: 'Weitere Informationen',
              description:
                'Weiter Informationen finden Sie in unserer <a class="cc__link" href="https://www.wellext.de/legal/datenschutz">Datenschutzerklärung</a>.'
            }
          ]
        }
      }
    }
  }
};
